var envConfig = require('./env.config')

var path = require('path')

module.exports = (function () {

  const config = Object.assign({
    dirs : {
      root: path.resolve(__dirname + '/../'),
      app : '/app',
      views : '/../app/views',
      partials : '/../app/views/partials'
    }
  }, envConfig)

  return config
}())



// WEBPACK FOOTER //
// ../config/index.js